<template>
	<ConfirmationDialog class="archive-goal-prompt">
		<template #header>
			<h1 class="archive-goal-prompt__heading">{{ $t( "common-gokr.components.ArchiveGoalPrompt.title" ) }}</h1>
		</template>
		<template #description>
			<main class="archive-goal-prompt__main">
				{{ $t( "common-gokr.components.ArchiveGoalPrompt.description" ) }}
			</main>
		</template>
		<template #actions>
			<footer class="archive-goal-prompt__footer">
				<TeamingButton
					size="SMALL"
					type="PRIMARY"
					:destructive="true"
					@click="$emit( `confirm` )"
				>
					{{ $t( "common-gokr.components.ArchiveGoalPrompt.confirmButton" ) }}
				</TeamingButton>
				<TeamingButton
					size="SMALL"
					type="QUATERNARY"
					@click="$emit( `dismiss` )"
				>
					{{ $t( "common-gokr.components.ArchiveGoalPrompt.dismissButton" ) }}
				</TeamingButton>
			</footer>
		</template>
	</ConfirmationDialog>
</template>

<script>
import { ConfirmationDialog, TeamingButton } from "@teaming/common-ui";
export default {
	name: "ArchiveGoalPrompt",
	emits: [ "confirm", "save", "dismiss", ],
	components: {
		ConfirmationDialog,
		TeamingButton,
	},
};
</script>

<style lang="scss" scoped>
$archive-goal-prompt-title-color: $color1-700;

.archive-goal-prompt__heading {
	@include font-and-line-for(1);
	font-weight: 600;
	color: $archive-goal-prompt-title-color;
}

.archive-goal-prompt__footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;
}
</style>
